import { Injectable } from '@angular/core';

import { SnColorPalette } from '@lib/common/types';
import { SnComponentUpdater } from '@lib/core';

import { ISnSmartBadgeEvent } from '../interfaces/smart-badge-event.interface';

@Injectable({ providedIn: 'root' })
export class SnSmartBadgeService {
  private readonly _badges = new Map<string, string>();

  constructor(private readonly _componentUpdater: SnComponentUpdater<ISnSmartBadgeEvent>) {}

  public getBadge(name: string): string {
    if (!this._badges.has(name)) {
      this._badges.set(name, null);
    }

    return this._badges.get(name);
  }

  public setBadge(name: string, value: string | number, color?: SnColorPalette): void {
    value = typeof value === 'number' ? value.toString() : value;

    this._badges.set(name, value);
    this._componentUpdater.updateComponent('snSmartBadge', { name, value, color });
  }
}
